import { useNavigate } from 'react-router'
import { useT } from '../lib/i18n'

export function NotFoundPage() {
  const navigate = useNavigate()
  const t = useT()
  return (
    <div className="app-shell items-center justify-center gap-4 px-6 text-center">
      <span
        aria-hidden="true"
        className="flex size-12 items-center justify-center rounded-full bg-accent/12 ring-1 ring-accent/30 ring-inset"
      >
        <span className="size-3 rounded-full bg-accent shadow-[0_0_16px_3px_rgb(232_176_75/0.45)]" />
      </span>
      <h1 className="text-title font-semibold text-ink">{t('notFound.title')}</h1>
      <p className="max-w-[24rem] text-ui text-muted">{t('notFound.body')}</p>
      <button
        type="button"
        onClick={() => void navigate('/', { replace: true })}
        className="mt-1 min-h-11 rounded-full bg-accent px-6 text-ui font-semibold press text-on-accent hover:bg-accent-strong"
      >
        {t('notFound.backToChats')}
      </button>
    </div>
  )
}
